import type React from 'react';

import { Box } from '@change-corgi/design-system-legacy/layout';

import { usePetitionDetailsPageData, usePetitionDetailsPageUserData } from 'src/app/pages/petitionDetails/pageContext';

import { useSapCtaTracking } from '../../hooks/tracking/sapCta';

import { SapCta } from './components/SapCta';

export const SapCtaContainer: React.FC = () => {
	const {
		data: {
			featureConfigs: { sapCtaEnabled },
		},
	} = usePetitionDetailsPageData();
	const {
		data: { canEdit, signed },
	} = usePetitionDetailsPageUserData();
	const { trackClick } = useSapCtaTracking();

	if (canEdit || !sapCtaEnabled || !signed) return null;

	return (
		<Box pt={24}>
			<SapCta onClick={trackClick} />
		</Box>
	);
};
